import buttonShapes from "@insite/mobius/Button/buttonShapes";

buttonShapes.rounded = () => `
    border-radius: .25em;
`;
